<template>
	<div class="main-container">
		<router-view></router-view>
		<!-- Navbar section -->
		<HeaderSoftware />

		<!-- hero section -->
		<HeroSoftware />

        <!-- business analytics start -->
        <div class="feature-icon-list-area section-space--pb_120 section-space--mt_40" id="about">
            <div class="container">
                <div class="section-title-wrapper text-center section-space--mb_100">
                    <h2 class="section-title font-weight--light mb-30 wow move-up">Características principales <br> de Datatonico</h2>
                </div>
            </div>
            <!-- feature list component -->
            <FeatureList />
        </div>

        <!-- tab two components -->
        <TabTwo BgGradient="bg-gradient" id="service" />

        <!-- accordion section -->
        <div class="software-accordion-wrapper section-space--pt_120 section-space--pb_60 gray-gradient" id="faq">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="section-title-wrapper text-center section-space--mb_60">
                            <h2 class="section-title font-weight--light mb-10 wow move-up">Preguntas frecuentes</h2>
                            <span class="section-text wow move-up">Nos preocupamos por responder todas tus dudas</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="faq-wrapper">
                            <!-- accordion component -->
                            <Accordion />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- newsletter section -->
        <Newsletter /> 

		<!-- footer section -->
        <FooterMain />

        <!-- offcanvas search component -->
        <OffcanvasSearchBox />

	</div>
</template>

<script>
	import HeaderSoftware from "../components/HeaderSoftware";
	import HeroSoftware from "../components/HeroSoftware";
	import FeatureList from "../components/FeatureList";
	import TabTwo from "../components/TabTwo";
	import Accordion from "../components/Accordion";
	import Newsletter from "../components/Newsletter";
	import FooterMain from "../components/FooterMain";
	import OffcanvasSearchBox from "../components/OffcanvasSearchBox";

	export default {
		name: "app",
		components: {
			HeaderSoftware,
			HeroSoftware,
            FeatureList,
            TabTwo,
            Accordion,
            Newsletter,
            FooterMain,
            OffcanvasSearchBox	
		},

        metaInfo: {
            title: 'Datatonico - Captura de datos de investigación clínica a medida',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        }
	};
</script>

